import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  INIT_URL,
  SIGNOUT_USER_SUCCESS,
  SET_USER_DATA,
  SESSION_STATUS_SET,
  SESSION_PROFILE_SET,
} from "constants/ActionTypes";
import RequestHandler from "../../util/RequestHandler";
import { notification } from "antd";
import { SESSION_STATUS } from "../../util/session";

export const setInitUrl = (url) => {
  return {
    type: INIT_URL,
    payload: url,
  };
};

export const setUserToken = (token) => {
  return {
    type: SET_USER_DATA,
    payload: token,
  };
};

export const userSignUp = ({ email, password, name }) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    RequestHandler.post("/auth/register", {
      email: email,
      password: password,
      name: name,
    })
      .then(({ data }) => {
        if (data.result) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({ type: SET_USER_DATA, payload: data.user });
        } else {
          dispatch({ type: FETCH_ERROR, payload: "Network Error" });
        }
      })
      .catch(function (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
      });
  };
};

export const userSignIn = (requestData) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });

    return RequestHandler.post(`/FirmAuth/Login`, requestData, false).then(
      (response) => {
        if (response.success) {
          RequestHandler.setUserInfo(response);
          // Enrich logo into in-memory profile
          return RequestHandler.get(`/FirmAuth/GetActiveTenantInfo`).then(
            (tenantResponse) => {
              if (tenantResponse?.success && tenantResponse?.data?.logoPath) {
                RequestHandler.setProfile({
                  ...RequestHandler.getProfileSnapshot(),
                  tenantLogo: tenantResponse.data.logoPath,
                });
              }
              const profile = RequestHandler.getProfileSnapshot();
              dispatch(setUserToken("cookie-session"));
              dispatch({
                type: SESSION_STATUS_SET,
                payload: SESSION_STATUS.AUTHENTICATED,
              });
              dispatch({ type: SESSION_PROFILE_SET, payload: profile });
              dispatch({ type: FETCH_SUCCESS });
              notification.success({
                message: "Giriş başarılı.",
                duration: 2,
              });
              return response;
            }
          );
        }

        dispatch({ type: FETCH_ERROR, payload: response.message });
        return response;
      }
    );
  };
};

export const changeTenant = (tenantId) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });

    return RequestHandler.get(`/FirmAuth/ChangeTenant/${tenantId}`).then(
      (response) => {
        if (response.success) {
          RequestHandler.setUserInfo(response);
          return RequestHandler.get(`/FirmAuth/GetActiveTenantInfo`).then(
            (tenantResponse) => {
              if (tenantResponse?.success && tenantResponse?.data?.logoPath) {
                RequestHandler.setProfile({
                  ...RequestHandler.getProfileSnapshot(),
                  tenantLogo: tenantResponse.data.logoPath,
                });
              }
              dispatch(setUserToken("cookie-session"));
              dispatch({
                type: SESSION_STATUS_SET,
                payload: SESSION_STATUS.AUTHENTICATED,
              });
              dispatch({
                type: SESSION_PROFILE_SET,
                payload: RequestHandler.getProfileSnapshot(),
              });
              dispatch({ type: FETCH_SUCCESS });
              window.location.reload();
              return response;
            }
          );
        }

        dispatch({ type: FETCH_ERROR, payload: response.message });
        return response;
      }
    );
  };
};

export const userSignOut = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    return RequestHandler.get("/FirmAuth/Logout", undefined, {
      skipRefresh: true,
    })
      .catch(() => null)
      .finally(() => {
        RequestHandler.removeUserInfo();
        dispatch({ type: FETCH_SUCCESS });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
        window.location = "/signin";
      });
  };
};
